import { render, staticRenderFns } from "./TableHeaderColumnOptions.vue?vue&type=template&id=1112fbef&scoped=true&"
import script from "./TableHeaderColumnOptions.vue?vue&type=script&lang=js&"
export * from "./TableHeaderColumnOptions.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderColumnOptions.vue?vue&type=style&index=0&id=1112fbef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112fbef",
  null
  
)

export default component.exports